import {
    IonItem,
    IonIcon,
    IonButton,
    useIonActionSheet,
    IonNote,
    IonText,
    IonCheckbox,
    IonRow
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    close,
    send,
    cloudDownload,
    caretDown,
    caretUp
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';

const A_SEND_RECEIPT = 'Send Receipt';
const A_RESEND_RECEIPT = 'Resend Receipt';


const PaymentTableListItems = ({
    paymentId, date, tenantName, status, amount, allPaymentsSelected,
    currency, showDetails, handlePaymentAction, message, handleSelect, onClickAssignTenant,
    userAllPerms,
    options, index
 }) => {

    const [showExtraDetails, setShowExtraDetails] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const [present] = useIonActionSheet();

    const [extraData, setExtraData] = useState([
        {label: 'Date', value: date},
        {label: 'Payment ID/Number', value: paymentId},
        {label: `${options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}`, value: tenantName},
        {label: 'Status', value: status},
        {label: 'Amount', value: amount + " " + currency}
    ])

    useEffect(() => {
        setExtraData(prevExtraData => {
            const updatedExtraData = [...prevExtraData];
            updatedExtraData.find(data => data.label === "Date").value = date;
            updatedExtraData.find(data => data.label === "Payment ID/Number").value = paymentId;
            updatedExtraData.find(data => data.label === `${options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}`).value = tenantName;
            updatedExtraData.find(data => data.label === "Status").value = status;
            updatedExtraData.find(data => data.label === "Amount").value = amount + " " + currency;
            return updatedExtraData;
        });
    }, [date, paymentId, tenantName, status, amount, currency]);

    useEffect(() => {
      if(allPaymentsSelected == 1){
          setIsChecked(true);
      }else if(allPaymentsSelected == 0){
          setIsChecked(false);
      }
    }, [allPaymentsSelected]);

    const actionsRequiringAllMessagePerms = [A_SEND_RECEIPT, A_RESEND_RECEIPT];

    const open = async () => {
        const mode = getMode();

        const buttons = [
              {
                text: message? A_RESEND_RECEIPT : A_SEND_RECEIPT,
                icon: mode !== 'ios' ? send : '',
                handler: () => {
                  handlePaymentAction("sendReceipt", paymentId);
                },
              },
              {
                text: 'Download Receipt',
                icon: mode !== 'ios' ? cloudDownload : '',
                handler: () => {
                  handlePaymentAction("downloadReceipt", paymentId);
                },
              },
              {
                text: 'Cancel',
                role: 'cancel',
                icon: mode !== 'ios' ? close : '',
                handler: () => {
                },
              },
            ];

            let filteredButtons = [];
            filteredButtons = buttons;
            if(!userAllPerms.message){
              filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllMessagePerms.includes(b.text))
            }

        present({
            header: tenantName + "  " + amount + " " + currency,
            buttons: filteredButtons
          });

      }

      useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails]);

    return (<IonItem  lines="none" key={paymentId}>
        <IonRow slot="start" style={{width: '100%'}} className='my-2 py-1 px-0 shadow-sm rounded'>
          <Row className='rounded'
          >
            <Col xs={1} sm={1} md={1} lg={1}>
                <IonCheckbox
                    checked={isChecked}
                    className='mr-2'
                    onIonChange={(e) => {
                        setIsChecked(e.target.checked);
                        handleSelect(paymentId, e.target.checked);
                    }}
                />
            </Col>
            <Col className='mx-0 pr-1' id={'showExtraDetails' + index}  onClick={ () => { setShowExtraDetails(!showExtraDetails)} }
              xs={7} md={6}
            >
              <Row className='mx-0 px-0'>
              <Col className='mx-1 px-0' xs={12} md={5}>
                {tenantName ? (<strong>{tenantName} <IonIcon icon={!showExtraDetails ? caretDown : caretUp }></IonIcon></strong>)
                :
                <div>
                  <IonButton
                    onClick={(e) => {onClickAssignTenant(paymentId, amount)}}>
                    Assign
                    </IonButton>
                    <IonIcon className="ml-2" icon={!showExtraDetails ? caretDown : caretUp } style={{ color: 'var(--ion-color-primary)' }}></IonIcon>
                  </div>}
                </Col>
              <Col className='mx-1 px-0' xs={12} md={7}>
                <IonNote>{date}
                </IonNote> &nbsp;
                <IonNote className='text-sm'>
                  {status}
                </IonNote>
              </Col>
              </Row>
            </Col>

            <Col xs={3} md={3} className='flex justify-content-end justify-content-md-start ml-1'>
              <IonText>
                <strong>{amount}</strong> &nbsp;
                <span className="text-sm">{currency}</span>
              </IonText>
            </Col>


            <Col xs={1} md={1} className='my-0 py-0 d-block d-md-none'>
              <IonButton onClick={open} fill="clear" className=''>
                  <IonIcon size="large" aria-hidden="true"  ios={ellipsisHorizontalSharp} md={ellipsisVerticalSharp} style={{ color: 'var(--ion-color-primary)' }} />
              </IonButton>
            </Col>
            <Col xs={1} md={1} className='my-0 py-0 d-none d-md-block'>
              <IonButton onClick={open} id='showActionSheet' fill="clear" className=''>
                  <IonIcon size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} style={{ color: 'var(--ion-color-primary)' }} />
              </IonButton>
            </Col>
          </Row>

            {showExtraDetails && (<Row style={{backgroundColor: colorTheme["primary"]["25"], overflowX: "hidden" }} className='mx-2 mr-3 mb-2 py-3 rounded tenant-list-row'>
              {extraData.map((data, index) => (
                    <Row key={index} className='border-bottom my-1 ml-1'>
                      <Col  xs={12} md={3}><strong>{data.label}</strong></Col>
                      <Col xs={12} md={8}>
                        <span style={{fontSize: '16px'}}>{data.value}</span>
                      </Col>
                    </Row>))}
            </Row>)}
        </IonRow>
    </IonItem>);
}

export default PaymentTableListItems;